export const enquiryOperationsList = {
  newEnquiry: "NEW_ENQUIRY",
  updateEnquiry: "UPDATE_ENQUIRY",
  listEnquiry: "LIST_ENQUIRY",
  previewEnquiry: "PREVIEW_ENQUIRY",
  enquiryTask: "ENQUIRY_TASK",
};

export const ENQUIRY_STATUS = {
  ENQUIRY: "Enquiry",
  // MOCK_UP_REQUIRED: "Mock-Up",
  REGISTER_PROJECT: "Register",
};
